(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mega-item"] && !Shopify.designMode) return;
  try {
    (function () {
    var MARGIN = 16;

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function fitSubmenu(item) {
      if (!item || isMobile()) return;
      var submenu = item.querySelector(':scope > .menu-list__submenu');
      if (!submenu || !submenu.querySelector('.mega-menu__column')) return;

      // Reset, then measure the natural (left-anchored) position.
      submenu.style.left = '0px';
      var rect = submenu.getBoundingClientRect();
      var overflowRight = rect.right - (window.innerWidth - MARGIN);

      if (overflowRight > 0) {
        // Shift left just enough to fit, but never past the left margin.
        var maxShift = rect.left - MARGIN;
        var shift = Math.min(overflowRight, maxShift);
        if (shift > 0) submenu.style.left = -shift + 'px';
      }
    }

    function handle(e) {
      var item = e.target.closest && e.target.closest('.menu-list__list-item');
      if (item) fitSubmenu(item);
    }

    document.addEventListener('pointerover', handle, true);
    document.addEventListener('focusin', handle, true);
    window.addEventListener('resize', function () {
      document.querySelectorAll('header-menu .menu-list__list-item').forEach(fitSubmenu);
    });

    // ------------------------------------------------------------------
    // Mobile: reshape the rendered mega blocks into Duel Kingdom Theme's existing
    // header-drawer drill-down structure, then let header-drawer.js drive it.
    // ------------------------------------------------------------------
    // Explicit chevrons — a forward ">" (drill in) and back "<", drawn directly
    // so the theme's icon-caret rotation can't turn them into a down caret.
    var FWD = '<svg class="mega-drawer__caret" viewBox="0 0 12 16" fill="none" aria-hidden="true" focusable="false"><path d="M4.5 3.5l5 4.5-5 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var BACK = '<svg class="mega-drawer__caret" viewBox="0 0 12 16" fill="none" aria-hidden="true" focusable="false"><path d="M7.5 3.5l-5 4.5 5 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CLOSE = '<svg class="mega-drawer__close" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : s;
      return d.innerHTML;
    }

    var building = false;
    var CHILD_CLASS = 'menu-drawer__menu-item menu-drawer__menu-item--child focus-inset';

    function textOf(el) {
      if (!el) return '';
      var t = el.querySelector('.wrap-text');
      return (t || el).textContent.trim();
    }

    function navButtons(titleText) {
      return (
        '<button class="button menu-drawer__back-button focus-inset" on:click="header-drawer/back" aria-label="' + esc(titleText) + '">' +
          '<span class="mega-drawer__icon">' + BACK + '</span>' +
          '<span class="menu-drawer__menu-item-text wrap-text">' + esc(titleText) + '</span>' +
        '</button>' +
        '<button class="button button-unstyled close-button menu-drawer__close-button" type="button" on:click="header-drawer/close" aria-label="Close">' +
          '<span class="mega-drawer__icon">' + CLOSE + '</span>' +
        '</button>'
      );
    }

    // A slide-in page (.menu-drawer__submenu). Returns { submenu, inner } so the
    // caller appends the page body to `inner`.
    function makePage(titleText) {
      var submenu = document.createElement('div');
      submenu.className = 'menu-drawer__submenu has-submenu';
      submenu.setAttribute('tabindex', '-1');
      var inner = document.createElement('div');
      inner.className = 'menu-drawer__inner-submenu';
      var nav = document.createElement('div');
      nav.className = 'menu-drawer__nav-buttons';
      nav.innerHTML = navButtons(titleText);
      inner.appendChild(nav);
      submenu.appendChild(inner);
      return { submenu: submenu, inner: inner };
    }

    // A drill-in row: a <details> whose summary slides `pageSubmenu` in.
    function drillItem(titleText, pageSubmenu) {
      var li = document.createElement('li');
      li.className = 'menu-drawer__list-item';
      var details = document.createElement('details');
      details.className = 'menu-drawer__menu-container';
      var summary = document.createElement('summary');
      summary.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist focus-inset';
      summary.setAttribute('on:click', 'header-drawer/open/submenu');
      summary.innerHTML =
        '<span class="menu-drawer__menu-item-text wrap-text">' + esc(titleText) + '</span>' +
        '<span class="mega-drawer__icon">' + FWD + '</span>';
      details.appendChild(summary);
      details.appendChild(pageSubmenu);
      li.appendChild(details);
      return li;
    }

    function linkItem(href, text, cls) {
      var li = document.createElement('li');
      li.className = 'menu-drawer__list-item';
      var a = document.createElement('a');
      a.className = cls || 'menu-drawer__menu-item menu-drawer__menu-item--mainlist focus-inset';
      a.setAttribute('href', href || '#');
      a.innerHTML =
        '<span class="menu-drawer__menu-item-text wrap-text">' + esc(text) + '</span>' +
        '<span class="mega-drawer__icon">' + FWD + '</span>';
      li.appendChild(a);
      return li;
    }

    function childList() {
      var ul = document.createElement('ul');
      ul.className = 'menu-drawer__menu menu-drawer__menu--childlist';
      ul.setAttribute('role', 'list');
      return ul;
    }

    // Build the drawer regardless of viewport (the drawer is only *shown* on
    // mobile via Duel Kingdom Theme's CSS, so building it on desktop is harmless and makes
    // the result universal — no dependence on the width at load time).
    //
    // Structure: item (level 1) -> menu of its column headers (level 2) ->
    // each column's image + links (level 3).
    function buildDrawerFromMega() {
      if (building) return;
      var menu = document.querySelector('header-drawer .menu-drawer__menu');
      var headerMenu = document.querySelector('.header-menu');
      if (!menu || !headerMenu) return;
      if (menu.getAttribute('data-mega-built') === '1') return;

      var items = headerMenu.querySelectorAll(':scope .menu-list__list > .menu-list__list-item');
      if (!items.length) return;

      building = true;
      var frag = document.createDocumentFragment();

      items.forEach(function (item) {
        var linkEl = item.querySelector(':scope > .menu-list__link');
        if (!linkEl) return;
        var title = textOf(item.querySelector('.menu-list__link-title')) || linkEl.textContent.trim();
        var href = linkEl.getAttribute('href') || '#';
        var grid = item.querySelector('.mega-menu__grid--blocks');
        var columns = grid ? grid.querySelectorAll(':scope > .mega-menu__column') : [];

        if (!columns.length) {
          frag.appendChild(linkItem(href, title));
          return;
        }

        // Level 2: a menu of this item's column headers.
        var l2 = makePage(title);
        var l2ul = childList();

        columns.forEach(function (col) {
          var parent = col.querySelector('.mega-menu__link--parent');
          var colTitle = textOf(parent);
          var titleHref = parent && parent.tagName === 'A' ? parent.getAttribute('href') : null;
          var colLinks = col.querySelectorAll('.mega-menu__link:not(.mega-menu__link--parent)');
          var image = col.querySelector('.mega-menu__image-link') || col.querySelector('.mega-menu__link-image');

          // An untitled column has no heading to drill into, so hoist its image
          // and links straight into the parent page rather than building a blank
          // drill-in row. (A single untitled column makes the item's page just a
          // flat list of that column's links — e.g. "Buy List".)
          if (!colTitle) {
            if (image) {
              var imgWrapFlat = document.createElement('div');
              imgWrapFlat.className = 'mega-drawer__column-image';
              var imgCloneFlat = image.cloneNode(true);
              imgCloneFlat.removeAttribute('id');
              if (imgCloneFlat.querySelectorAll) {
                imgCloneFlat.querySelectorAll('[id],[ref]').forEach(function (n) { n.removeAttribute('id'); n.removeAttribute('ref'); });
              }
              imgWrapFlat.appendChild(imgCloneFlat);
              l2.inner.appendChild(imgWrapFlat);
            }
            colLinks.forEach(function (lnk) {
              l2ul.appendChild(linkItem(lnk.getAttribute('href'), textOf(lnk), CHILD_CLASS));
            });
            return;
          }

          // A column with no sub-links is just a link to its destination.
          if (!colLinks.length) {
            l2ul.appendChild(linkItem(titleHref || '#', colTitle, CHILD_CLASS));
            return;
          }

          // Level 3: the column's (bigger) image + its links.
          var l3 = makePage(colTitle);

          if (image) {
            var imgWrap = document.createElement('div');
            imgWrap.className = 'mega-drawer__column-image';
            var imgClone = image.cloneNode(true);
            imgClone.removeAttribute('id');
            if (imgClone.querySelectorAll) {
              imgClone.querySelectorAll('[id],[ref]').forEach(function (n) { n.removeAttribute('id'); n.removeAttribute('ref'); });
            }
            imgWrap.appendChild(imgClone);
            l3.inner.appendChild(imgWrap);
          }

          var l3ul = childList();
          colLinks.forEach(function (lnk) {
            l3ul.appendChild(linkItem(lnk.getAttribute('href'), textOf(lnk), CHILD_CLASS));
          });
          l3.inner.appendChild(l3ul);

          l2ul.appendChild(drillItem(colTitle, l3.submenu));
        });

        l2.inner.appendChild(l2ul);
        frag.appendChild(drillItem(title, l2.submenu));
      });

      menu.textContent = '';
      menu.appendChild(frag);
      menu.setAttribute('data-mega-built', '1');
      building = false;
    }

    // The drawer re-renders itself after load (Duel Kingdom Theme's Section Rendering
    // second pass / morph), which wipes our injected content. Watch for that
    // and rebuild, so it works the same in every browser/viewport.
    function start() {
      buildDrawerFromMega();
      var hd = document.querySelector('header-drawer');
      if (!hd || !('MutationObserver' in window)) return;
      var obs = new MutationObserver(function () {
        if (building) return;
        var menu = hd.querySelector('.menu-drawer__menu');
        if (menu && menu.getAttribute('data-mega-built') !== '1') buildDrawerFromMega();
      });
      obs.observe(hd, { childList: true, subtree: true });
    }

    if (document.readyState !== 'loading') {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start);
    }
    window.addEventListener('resize', buildDrawerFromMega);
  })();
  } catch(e) { console.error(e); }
})();

})();
